<template>
    <div class="d-flex main">
        <div class="side d-flex" v-show="isMenuOpen">
            <SidebarComponent />
            <DatabarComponent :key="$route.params.chatId" @menuClose="isMenuOpen = false" />
        </div>

        <NavbarComponent @modelChanged="modelChanged" @deleteChat="chatDelete" :showModelSelect="false" :chatId="chatId"
            @menuOpen="isMenuOpen = true" />

        <div class="vertical-center">
            <h1>Вскоре</h1>
            <p>Мы работаем над новыми функциями 💡</p>
        </div>
    </div>
</template>

<script>
import SidebarComponent from "@/components/SidebarComponent.vue";
import DatabarComponent from "@/components/DatabarComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";

export default {
    name: 'AboutView',
    components: {
        SidebarComponent,
        DatabarComponent,
        NavbarComponent
    },

    data() {
        return {
            isMenuOpen: window.innerWidth >= 810,
            chatId: null,
        };
    },
}
</script>